/**
 * @generated SignedSource<<9085912aa3d5116234267d4c65ee6c4c>>
 * @relayHash 1b66ee5f20287b14bc7bb9af4b39bba6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6edc214d285d9fd84ef132e2f3c9ccfa65e581dd33c9e3f0897919fa1b0310f5

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SettingsViewQuery_TeamsSettingsQuery$variables = {
  orgId: string;
  permissionsEnabled: boolean;
  scopeId: string;
  shouldLoadCustomFields: boolean;
  shouldLoadNotifications: boolean;
  shouldLoadTeamTypeEdit: boolean;
  shouldLoadTeamTypes: boolean;
  siteId: string;
  teamTypeId: string;
};
export type SettingsViewQuery_TeamsSettingsQuery$data = {
  readonly team?: {
    readonly " $fragmentSpreads": FragmentRefs<"NotificationsTable_teamNotifications">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CustomFieldsScreen_data" | "SettingsHeader_TeamTypeEditPageTitle_data" | "TeamTypesEditScreenNext_data" | "TeamTypesScreen_data">;
};
export type SettingsViewQuery_TeamsSettingsQuery = {
  response: SettingsViewQuery_TeamsSettingsQuery$data;
  variables: SettingsViewQuery_TeamsSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "permissionsEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scopeId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldLoadCustomFields"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldLoadNotifications"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldLoadTeamTypeEdit"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldLoadTeamTypes"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamTypeId"
},
v9 = {
  "kind": "Variable",
  "name": "organizationId",
  "variableName": "orgId"
},
v10 = {
  "kind": "Variable",
  "name": "siteId",
  "variableName": "siteId"
},
v11 = {
  "kind": "Variable",
  "name": "scopeId",
  "variableName": "scopeId"
},
v12 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamTypeId"
  },
  (v11/*: any*/)
],
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "kind": "ScalarField",
  "name": "name"
},
v15 = [
  (v13/*: any*/),
  (v14/*: any*/)
],
v16 = [
  (v11/*: any*/)
],
v17 = {
  "kind": "ScalarField",
  "name": "verified"
},
v18 = {
  "kind": "ScalarField",
  "name": "description"
},
v19 = {
  "kind": "ScalarField",
  "name": "default"
},
v20 = {
  "kind": "ScalarField",
  "name": "state"
},
v21 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v22 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v23 = {
  "kind": "ScalarField",
  "name": "isVerified"
},
v24 = {
  "kind": "ScalarField",
  "name": "largeAvatarImageUrl"
},
v25 = {
  "concreteType": "TeamType",
  "kind": "LinkedField",
  "name": "type",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v13/*: any*/)
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "type"
},
v27 = {
  "fields": [
    {
      "items": [
        {
          "kind": "Variable",
          "name": "teamTypeIds.0",
          "variableName": "teamTypeId"
        }
      ],
      "kind": "ListValue",
      "name": "teamTypeIds"
    }
  ],
  "kind": "ObjectValue",
  "name": "teamTypes"
},
v28 = {
  "kind": "Literal",
  "name": "showEmptyTeams",
  "value": true
},
v29 = [
  {
    "fields": [
      {
        "kind": "Literal",
        "name": "query",
        "value": ""
      },
      (v27/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  (v9/*: any*/),
  (v28/*: any*/),
  (v10/*: any*/)
],
v30 = [
  {
    "kind": "Variable",
    "name": "ari",
    "variableName": "orgId"
  }
],
v31 = {
  "kind": "ScalarField",
  "name": "notificationType"
},
v32 = {
  "kind": "ScalarField",
  "name": "notificationChannel"
},
v33 = {
  "kind": "ScalarField",
  "name": "enabled"
},
v34 = {
  "kind": "ScalarField",
  "name": "ari"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SettingsViewQuery_TeamsSettingsQuery",
    "selections": [
      {
        "condition": "shouldLoadTeamTypes",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TeamTypesScreen_data"
          }
        ]
      },
      {
        "condition": "shouldLoadTeamTypeEdit",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v9/*: any*/),
              {
                "kind": "Variable",
                "name": "permissionsEnabled",
                "variableName": "permissionsEnabled"
              },
              (v10/*: any*/),
              {
                "kind": "Variable",
                "name": "teamTypeId",
                "variableName": "teamTypeId"
              }
            ],
            "kind": "FragmentSpread",
            "name": "TeamTypesEditScreenNext_data"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "SettingsHeader_TeamTypeEditPageTitle_data"
      },
      {
        "condition": "shouldLoadCustomFields",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CustomFieldsScreen_data"
          }
        ]
      },
      {
        "condition": "shouldLoadNotifications",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "NotificationsTable_teamNotifications"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v8/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SettingsViewQuery_TeamsSettingsQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": (v12/*: any*/),
            "concreteType": "TeamType",
            "kind": "LinkedField",
            "name": "typeInformation",
            "plural": false,
            "selections": (v15/*: any*/)
          }
        ]
      },
      {
        "condition": "shouldLoadTeamTypes",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": (v16/*: any*/),
                "concreteType": "TeamTypeConnection",
                "kind": "LinkedField",
                "name": "typesWithinScope",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TeamTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TeamType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v17/*: any*/),
                          (v14/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldLoadTeamTypeEdit",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": (v12/*: any*/),
                "concreteType": "TeamType",
                "kind": "LinkedField",
                "name": "typeInformation",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v17/*: any*/),
                  (v19/*: any*/)
                ]
              },
              {
                "args": (v16/*: any*/),
                "concreteType": "TeamTypeConnection",
                "kind": "LinkedField",
                "name": "typesWithinScope",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TeamTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TeamType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v19/*: any*/),
                          (v13/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "permissionsEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v12/*: any*/),
                    "concreteType": "TeamType",
                    "kind": "LinkedField",
                    "name": "typeInformation",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TeamTypePermissionDelegationConnection",
                        "kind": "LinkedField",
                        "name": "typeLevelPermissions",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TeamTypeLevelPermissionDelegation",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TeamTypeLevelPermissionDetails",
                                "kind": "LinkedField",
                                "name": "permissions",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "permission"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "granted"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canBeModified"
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v21/*: any*/),
                                          (v13/*: any*/),
                                          (v14/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "picture"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "email"
                                              }
                                            ],
                                            "type": "AtlassianAccountUser"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "TeamTypePermissionAssignedUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "IdentityGroup",
                                        "kind": "LinkedField",
                                        "name": "group",
                                        "plural": false,
                                        "selections": (v15/*: any*/)
                                      }
                                    ],
                                    "type": "TeamTypePermissionAssignedGroup"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "TeamV2",
                                        "kind": "LinkedField",
                                        "name": "team",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v22/*: any*/),
                                          (v23/*: any*/),
                                          (v24/*: any*/),
                                          (v20/*: any*/),
                                          (v25/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "TeamTypePermissionAssignedTeam"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v26/*: any*/)
                                    ],
                                    "type": "TeamTypeLevelDefaultPermissionEntity"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": (v29/*: any*/),
                "concreteType": "TeamSearchResultConnectionV2",
                "kind": "LinkedField",
                "name": "teamSearchV2",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TeamSearchResultEdgeV2",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TeamSearchResultV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v22/*: any*/),
                              (v18/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v20/*: any*/),
                              (v25/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "memberCount"
                          },
                          (v21/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v29/*: any*/),
                "filters": [
                  "organizationId",
                  "siteId",
                  "filter",
                  "showEmptyTeams"
                ],
                "handle": "connection",
                "key": "TeamsTable_teamSearchV2",
                "kind": "LinkedHandle",
                "name": "teamSearchV2"
              }
            ]
          },
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": (v16/*: any*/),
                "concreteType": "TeamTypeConnection",
                "kind": "LinkedField",
                "name": "typesWithinScope",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TeamTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TeamType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v18/*: any*/),
                          (v17/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "hasTeams",
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "fields": [
                      (v27/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 5
                  },
                  (v9/*: any*/),
                  (v28/*: any*/),
                  (v10/*: any*/)
                ],
                "concreteType": "TeamSearchResultConnectionV2",
                "kind": "LinkedField",
                "name": "teamSearchV2",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TeamSearchResultEdgeV2",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v21/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldLoadCustomFields",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": (v16/*: any*/),
                "concreteType": "TeamCustomFieldInfo",
                "kind": "LinkedField",
                "name": "customFieldsWithinScope",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v26/*: any*/),
                  (v14/*: any*/),
                  (v18/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldLoadNotifications",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": (v30/*: any*/),
                "concreteType": "TeamNotificationConfiguration",
                "kind": "LinkedField",
                "name": "notificationConfigurations",
                "plural": true,
                "selections": [
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/)
                ]
              },
              {
                "args": (v30/*: any*/),
                "concreteType": "TeamScopeNotificationConfiguration",
                "kind": "LinkedField",
                "name": "scopeNotificationConfigurations",
                "plural": true,
                "selections": [
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v34/*: any*/),
                  (v33/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6edc214d285d9fd84ef132e2f3c9ccfa65e581dd33c9e3f0897919fa1b0310f5",
    "metadata": {},
    "name": "SettingsViewQuery_TeamsSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6a5bf18199797b9ea53901e85bc2ffff";

export default node;
